var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:assignment-turned-in-outline-rounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6 13.25L8.45 11.1C8.26667 10.9167 8.03334 10.825 7.75 10.825C7.46667 10.825 7.23334 10.9167 7.05 11.1C6.86667 11.2833 6.775 11.5167 6.775 11.8C6.775 12.0833 6.86667 12.3167 7.05 12.5L9.9 15.35C10.1 15.55 10.3333 15.65 10.6 15.65C10.8667 15.65 11.1 15.55 11.3 15.35L16.95 9.7C17.1333 9.51667 17.225 9.28333 17.225 9C17.225 8.71667 17.1333 8.48333 16.95 8.3C16.7667 8.11667 16.5333 8.025 16.25 8.025C15.9667 8.025 15.7333 8.11667 15.55 8.3L10.6 13.25ZM5 21C4.45 21 3.979 20.804 3.587 20.412C3.195 20.02 2.99934 19.5493 3 19V5C3 4.45 3.196 3.979 3.588 3.587C3.98 3.195 4.45067 2.99933 5 3H9.2C9.41667 2.4 9.77934 1.91667 10.288 1.55C10.7967 1.18333 11.3673 1 12 1C12.6333 1 13.2043 1.18333 13.713 1.55C14.2217 1.91667 14.584 2.4 14.8 3H19C19.55 3 20.021 3.196 20.413 3.588C20.805 3.98 21.0007 4.45067 21 5V19C21 19.55 20.804 20.021 20.412 20.413C20.02 20.805 19.5493 21.0007 19 21H5ZM5 19H19V5H5V19ZM12 4.25C12.2167 4.25 12.3957 4.179 12.537 4.037C12.6783 3.895 12.7493 3.716 12.75 3.5C12.75 3.28333 12.679 3.10433 12.537 2.963C12.395 2.82167 12.216 2.75067 12 2.75C11.7833 2.75 11.6043 2.821 11.463 2.963C11.3217 3.105 11.2507 3.284 11.25 3.5C11.25 3.71667 11.321 3.89567 11.463 4.037C11.605 4.17833 11.784 4.24933 12 4.25Z",
    fill: "#4A4A4A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checked-icon.d5a5264635f28b5a0262d0742e29e454.svg";
export { ForwardRef as ReactComponent };